<template>
  <div>
    <b-overlay :show="showSpinner" rounded="sm">
      <b-card title="Admin Log">
        <b-row class="mb-2">
          <b-col cols="6">
            <b-form-input
              v-model="search"
              @input="debounceSearch"
              type="text"
              placeholder="Search User, Action, or Item Type"
            />
          </b-col>
        </b-row>
        <b-table
          hover
          responsive
          head-variant="dark"
          small
          outlined
          :items="dataTable"
          :fields="headers"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          show-empty
        >
          <template v-slot:cell(createdAt)="row">
            {{ row.item.createdAt ? new Date(row.item.createdAt).toLocaleString() : '' }}
          </template>
          <template v-slot:cell(actions)="row">
            <b-button size="sm" variant="primary" @click="goToDetail(row.item)">
              <feather-icon size="1x" icon="EyeIcon"/>
            </b-button>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4" class="pt-1">
            <b-form-group label="Data Per Page" label-for="per-page-select" class="mb-0">
              <v-select
                id="per-page-select"
                class="select-sm"
                :clearable="false"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
                @input="fetchData()"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col class="pt-1">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              @change="onPageChange"
              :total-rows="totalRows"
              first-number
              last-number
              class="float-right"
              aria-controls="admin-log-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      showSpinner: false,
      headers: [
        { key: 'user', label: 'User', sortable: true },
        { key: 'action', label: 'Action', sortable: true },
        { key: 'itemType', label: 'Item Type', sortable: true },
        { key: 'createdAt', label: 'Date', sortable: true },
        { key: 'actions', label: 'Details' }
      ],
      sortBy: 'createdAt',
      sortDesc: true,
      perPage: 10,
      pageOptions: [5, 10, 20, 50],
      currentPage: 1,
      totalRows: 0,
      debounce: null
    }
  },
  computed: {
    dataTable() {
      return this.$store.getters['admin/getDataLog'];
    }
  },
  methods: {
    debounceSearch() {
      this.showSpinner = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.showSpinner = false;
        this.currentPage = 1;
        this.fetchData();
      }, 600);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    fetchData() {
      this.showSpinner = true;
      this.$store.dispatch('admin/getAdminLog', {
        search: this.search,
        page: this.currentPage,
        entry: this.perPage
      })
      .then(res => {
        res.totalData ? this.totalRows = res.totalData : this.totalRows = 0;
        this.showSpinner = false;
      })
      .catch(err => {
        this.showSpinner = false;
        this.totalRows = 0;
        this.$bvToast && this.$bvToast.toast('Error get data', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        console.error(err);
      });
    },
    goToDetail(item) {
      this.$router.push({
        name: 'detail-data-manager-log',
        params: { id: item.id }
      });
    }
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    perPage() {
      this.currentPage = 1;
      this.fetchData();
    }
  }
}
</script>